import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
//
import Loader from 'components/loaders/main';
import { ELoadingType, ILoadingState } from 'store/loading/types';
import colors from 'theme/colors';
import loadingImage from 'assets/images/landing-image.jpg';

const { loadingProviderBackground } = colors;

const Container = styled.div({
  alignItems: 'center',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  position: 'fixed',
  width: '100vw',
  zIndex: 10,
});

const LoadingImage = styled.img({
  objectPosition: 'left',
  position: 'fixed',
  objectFit: 'cover',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
});

const LoaderContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 2;
  height: 0px;
  width: 155px;
  padding: 26px;
  border-radius: 4px;
`;

const SpinnerContainer = styled.div({
  alignItems: 'center',
  backgroundColor: loadingProviderBackground,
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  position: 'fixed',
  width: '100vw',
  zIndex: 10,
});
const themeSpacing = 2;
const useStyles = makeStyles(theme => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(themeSpacing),
    },
  },
}));

export default ({ loading }: ILoadingState) => {
  const classes = useStyles();

  if (loading === ELoadingType.OPENING_IMAGE) {
    return (
      <Container data-testid="tid-loading-opening-image">
        <LoadingImage src={loadingImage} />
        <LoaderContainer className={classes.root}>
          <LinearProgress color="primary" />
        </LoaderContainer>
      </Container>
    );
  }

  if (loading === ELoadingType.SPINNER) {
    return (
      <SpinnerContainer data-testid="tid-loading-spinner">
        <Loader />
      </SpinnerContainer>
    );
  }

  return null;
};
